/**
 * Tooltip on Radix. DESIGN.md names the tooltip a 10px-radius overlay (§Shapes "menu 10px
 * ... tooltips") that casts the pass shadow; stars.css `.tip` is the reference (12px/600
 * text, 6px 10px padding, shadow-2). Here it is the inverse surface (text-inverse on
 * surface-inverse) at the `xs` step (12px/600 as `.tip`), with 8px 12px padding, the nearest scale steps.
 * Wrap the app (or a screen) in TooltipProvider once; Radix throws without one.
 */
import React from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { cn } from './cn';
import { SurfaceRoot, useSurfaceClass } from './surface';

export function TooltipProvider({ delayDuration = 300, ...props }) {
  return <RadixTooltip.Provider delayDuration={delayDuration} {...props} />;
}

function TooltipBody({ content, side, arrow }) {
  const surfaceClass = useSurfaceClass();
  return (
    <RadixTooltip.Portal>
      <RadixTooltip.Content
        side={side}
        sideOffset={6}
        className={cn('tw-z-50 tw-max-w-xs tw-px-3 tw-py-2 tw-rounded-md tw-bg-surface-inverse tw-text-text-inverse tw-text-xs tw-font-semibold tw-shadow-2', surfaceClass)}
      >
        {content}
        {arrow && <RadixTooltip.Arrow className="tw-fill-surface-inverse" />}
      </RadixTooltip.Content>
    </RadixTooltip.Portal>
  );
}

export function Tooltip({ content, children, side = 'top', arrow = false, open, defaultOpen, onOpenChange, delayDuration, surface }) {
  return (
    <RadixTooltip.Root open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange} delayDuration={delayDuration}>
      <SurfaceRoot surface={surface}>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <TooltipBody content={content} side={side} arrow={arrow} />
      </SurfaceRoot>
    </RadixTooltip.Root>
  );
}
